var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jazzicon',{staticClass:"d-inline-block v-align-middle line-height-0",attrs:{"address":_vm.address,"diameter":_vm.diameter}})}
var staticRenderFns = []

export { render, staticRenderFns }